import React, { useState, useEffect } from 'react';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import Header from '../../Components/Header/header';
import { useLocation } from "react-router-dom";
import './employeeclaim.css';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const EmployeeClaimStatusScreen = () => {

  const location = useLocation();

const storedUser = JSON.parse(localStorage.getItem("user"));

const emp_id = location.state?.emp_id || storedUser?.emp_id;
const org_id = location.state?.org_id || storedUser?.org_id;
    const [employeeData, setEmployeeData] = useState({});
    const [formData, setFormData] = useState({
        empid: '',
        fullName: '',
        emailid: '',
        familyDefinition: "",  
        claimType: '',
        memberName: '',
        memberType: '',
        patientName: '',
        spousename: '',
        child: '',
        second_child: '',
        fathername: '',
        mothername: '',
        fatherinlawname: '',
        motherinlawname: '',
        relation: '',
        hospitalName: '',
        admissionDate: '',
        dischargeDate: '',
        amount: '',
        remarks: '',
        documents: null,
        insurerEmailID: '',
    });

    const [filePreview, setFilePreview] = useState({ title: '', summary: '' });
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);

    const today = new Date();
    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0); // last day of current month

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Error parsing user data:", e);
            }
        }
    }, []);


    const buildFamilyDefinition = (data) => {
        let def = "";

        if (data.family_spouse) def += "Spouse ";
        if (data.family_child) def += `Child (${data.no_of_children}) `;
        if (data.family_parents) def += "Parents ";
        if (data.family_inlaws) def += "In-LawsParents";

        return def.trim();
    };

    const getAllowedMembers = () => {
        const def = formData.familyDefinition || "";
        let members = [];

        // Self always
        members.push("Self");

        if (def.includes("Spouse")) {
            members.push("Spouse");
        }
        const match = def.match(/Child\s*\((\d+)\)/);
        if (match) {
            const count = parseInt(match[1], 10);
            if (count >= 1) members.push("Child");
            if (count >= 2) members.push("Second Child");
            if (count >= 3) members.push("Third Child");
        }

        if (def.includes("Parents") && !def.includes("In-LawsParents")) {
            members.push("Father", "Mother");
        }

        if (def.includes("In-LawsParents")) {
            members.push("Father-in-law", "Mother-in-law");
        }

        return members;
    };


    const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
    };

    const admissionDateLimits = {
        min: formData.policyStart || "",
        max: formData.policyEnd || ""
    };

    const dischargeDateLimits = {
        min: formData.admissionDate || formData.policyStart || "",
        max: formData.policyEnd
            ? formatDate(new Date(new Date(formData.policyEnd).getTime() - 86400000))
            : ""
    };

    const handleChange = async (e) => {
        const { name, type, value, files } = e.target;

        if (type === 'file') {
            if (files.length > 0) {
                const file = files[0];
                setFormData(prev => ({ ...prev, documents: file }));

                if (file.type === 'application/pdf') {
                    const fileReader = new FileReader();
                    fileReader.onload = async function () {
                        const typedarray = new Uint8Array(this.result);
                        const pdf = await pdfjsLib.getDocument(typedarray).promise;
                        const page = await pdf.getPage(1);
                        const textContent = await page.getTextContent();
                        const textItems = textContent.items.map(item => item.str);
                        setFilePreview({
                            title: file.name,
                            summary: textItems.slice(0, 5).join(' ') + ' ...'
                        });
                    };
                    fileReader.readAsArrayBuffer(file);
                } else if (file.type.startsWith('image/')) {
                    const imageUrl = URL.createObjectURL(file);
                    setFilePreview({
                        title: file.name,
                        summary: <img src={imageUrl} alt="preview" style={{ maxWidth: '100px' }} />
                    });
                } else {
                    setFilePreview({ title: file.name, summary: 'File selected' });
                }
            } else {
                setFormData(prev => ({ ...prev, documents: null }));
                setFilePreview({ title: '', summary: '' });
            }
        } else {
            if (name === 'empid') {
                setEmployeeData({});
                setFormData(prev => ({
                    ...prev,
                    empid: value,
                    fullName: '',
                    emailid: '',
                    patientName: '',
                }));
            } else {
                setFormData(prev => ({ ...prev, [name]: value }));
            }
        }
    };

    useEffect(() => {
  if (emp_id) {
    setFormData((prev) => ({
      ...prev,
      empid: emp_id,
    }));
  }
}, [emp_id]);

    useEffect(() => {
        if (!formData.empid.trim()) {
            setEmployeeData({});
            setFormData(prev => ({
                ...prev,
                fullname: '',
                emailid: '',
                patientName: '',
            }));
            return;
        }

        const delayDebounce = setTimeout(() => {
            const empidPattern = /^(\d+|EMP\d+)$/i;

            if (!empidPattern.test(formData.empid.trim())) {
                setEmployeeData({});
                setFormData(prev => ({
                    ...prev,
                    fullname: '',
                    emailid: '',
                    patientName: '',
                }));
                return;
            }

            const fetchEmployeeDataById = async () => {
                try {
                    const empid = formData.empid.trim();

                    const storedUser = JSON.parse(localStorage.getItem("user"));
                    if (!storedUser || !storedUser.org_id) {
                        alert("⚠️ Organization not found.");
                        return;
                    }

                    const orgId = storedUser.org_id;

                    const res = await fetch(
                        `/api/employeeById/${empid}?org_id=${orgId}`
                    );

                    if (!res.ok) {
                        if (res.status === 404) alert("❌ Employee not found or inactive.");
                        else alert("⚠️ Failed to fetch employee details.");
                        setEmployeeData({});
                        return;
                    }

                    const data = await res.json();

                    setEmployeeData(data);
                    setFormData(prev => ({
                        ...prev,
                        fullname: data.fullname || '',
                        emailid: data.emailid || '',
                        patientName: '',
                        scheme_id: data.scheme_id || '',
                        scheme_name: data.scheme_name || '',
                        policyStart: data.start_date ? data.start_date.split("T")[0] : '',
                        policyEnd: data.end_date ? data.end_date.split("T")[0] : '',
                        insurerEmailID: data.insurer_email || '',
                        sumInsuredBalance: data.sum_insured_bal || '',
                        familyDefinition: buildFamilyDefinition(data)
                    }));

                } catch (error) {
                    console.error("Error fetching employee data:", error);
                    alert("⚠️ Error connecting to server.");
                }
            };



            fetchEmployeeDataById();
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [formData.empid]);

    useEffect(() => {
        if (!formData.memberType || !employeeData || Object.keys(employeeData).length === 0) return;

        let name = "";

        switch (formData.memberType) {
            case "Self":
                name = employeeData.fullname || "";
                break;

            case "Spouse":
                name = employeeData.spousename || "";
                break;

            case "Child":
                name = employeeData.child1_name || "";
                break;

            case "Second Child":
                name = employeeData.child2_name || "";
                break;

            case "Third Child":
                name = employeeData.child3_name || "";
                break;

            case "Father":
                name = employeeData.fathername || "";
                break;

            case "Mother":
                name = employeeData.mothername || "";
                break;

            case "Father-in-law":
                name = employeeData.fatherinlawname || "";
                break;

            case "Mother-in-law":
                name = employeeData.motherinlawname || "";
                break;

            default:
                name = "";
        }

        setFormData(prev => ({
            ...prev,
            patientName: name
        }));
    }, [formData.memberType, employeeData]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (!formData.documents) {
                alert('⚠️ Please upload a document before submitting.');
                setLoading(false);
                return; 
            }
            const formDataToSend = new FormData();
            Object.keys(formData).forEach(key => {
                if (formData[key] !== null && formData[key] !== '') {
                    formDataToSend.append(key, formData[key]);
                }
            });

            formDataToSend.append("org_id", localStorage.getItem("org_id"));
            formDataToSend.append("scheme_id", formData.scheme_id || '');
            formDataToSend.append("scheme_name", formData.scheme_name || '');

            const response = await fetch('/api/claim-request', {
                method: 'POST',
                body: formDataToSend
            });

            if (response.ok) {
                alert('✅ Claim submitted successfully!');
                setFormData({
                    empid: '', fullName: '', emailid: '', claimType: '',
                    memberName: '', memberType: '', patientName: '', relation: '',
                    hospitalName: '', admissionDate: '', dischargeDate: '', amount: '',
                    remarks: '', documents: null, insurerEmailID: ''
                });
                setFilePreview({ title: '', summary: '' });
                setEmployeeData({});
            } else {
                const err = await response.json();
                alert('❌ Submission failed: ' + err.error);
            }
        } catch (error) {
            console.error('❌ Error submitting claim:', error.message);
            alert('Something went wrong while submitting the claim.');
        }

        setLoading(false);
    };


    return (
        <div className="hrdashboard-container claimrequest-screen">
            <aside className="sidebar">
                <Header />
            </aside>
            <main className="main-content">
               

                <div className="dashboard-cards">
                    <div className="card claim-card">
                        <h2>Claim Request</h2>
                        <form className="claim-form two-column-layout" onSubmit={handleSubmit}>
                            {/* Employee ID */}
<div className="form-row-claim">
  <label>Employee ID</label>
  <input
    type="text"
    name="empid"
    value={formData.empid || ""}
    onChange={handleChange}
    required
  />
</div>

                            {/* Employee Name */}
                            <div className="form-row-claim">
                                <label>Employee Name</label>
                                <input type="text" name="fullName" value={formData.fullname} readOnly required />
                            </div>
                            {/* Scheme ID */}
                            <div className="form-row-claim">
                                <label>Scheme ID</label>
                                <input type="text" name="scheme_id" value={formData.scheme_id || ''} readOnly />
                            </div>

                            {/* Scheme Name */}
                            <div className="form-row-claim">
                                <label>Scheme Name</label>
                                <input type="text" name="scheme_name" value={formData.scheme_name || ''} readOnly />
                            </div>

                            {/* Company Email */}
                            <div className="form-row-claim">
                                <label>Company Email</label>
                                <input type="email" name="emailid" value={formData.emailid} readOnly required />
                            </div>

                            {/* Claim Type */}
                            <div className="form-row-claim">
                                <label>Claim Type</label>
                                <select name="claimType" value={formData.claimType} onChange={handleChange} required>
                                  <option value="">--Select--</option>
                                  <option value="Hospitalization">Hospitalization</option>
                                  <option value="Pre-Hospitalization">Pre-Hospitalization</option>
                                  <option value="Post-Hospitalization">Post-Hospitalization</option>
                                  <option value="OPD">OPD</option>
                                  <option value="Maternity">Maternity</option>
                                  <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="form-row-claim">
                                <label>Family Definition</label>
                                <input
                                    type="text"
                                    name="familyDefinition"
                                    value={formData.familyDefinition}
                                    readOnly
                                    placeholder="Based on Scheme"
                                />
                            </div>
                            {/* Member Type */}
                            <div className="form-row-claim">
                                <label>Member Type</label>
                                <select
                                    name="memberType"
                                    value={formData.memberType}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Member</option>
                                    {getAllowedMembers().map((m) => (
                                        <option key={m} value={m}>{m}</option>
                                    ))}
                                </select>
                            </div>


                            {/* Patient Name */}
                            <div className="form-row-claim">
                                <label>Patient Name</label>
                                <input type="text" name="patientName" value={formData.patientName} readOnly placeholder="Auto-fill" required />
                            </div>

                            {/* Hospital Name */}
                           

                            {/* Admission & Discharge */}
                            <div className="form-row-claim">
                                <label>Date of Admission</label>
                                <input
                                    type="date"
                                    name="admissionDate"
                                    value={formData.admissionDate}
                                    min={formatDate(currentMonthStart)}
                                    max={formatDate(currentMonthEnd)}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-row-claim">
                                <label>Date of Discharge</label>
                                <input
                                    type="date"
                                    name="dischargeDate"
                                    value={formData.dischargeDate}
                                    min={formatDate(currentMonthStart)}
                                    max={formatDate(currentMonthEnd)}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Sum Insured Balance */}
                            <div className="form-row-claim">
                                <label>Sum Insured Balance (₹)</label>
                                <input
                                    type="text"
                                    name="sumInsuredBalance"
                                    value={formData.sumInsuredBalance || ''}
                                    readOnly
                                />

                            </div>

                            {/* Amount */}
                            <div className="form-row-claim">
                                <label>Claim Amount (₹)</label>
                                <input
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    required
                                    min="0"
                                    step="0.01"
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        const max = Number(formData.sumInsuredBalance);

                                        if (value > max) {
                                            alert(`Claim Amount cannot exceed Sum Insured Balance (₹${max})`);
                                            return; // prevent update
                                        }

                                        setFormData(prev => ({ ...prev, amount: value }));
                                    }}
                                />

                            </div>
                            <div className="form-row-claim">
                                <label>Hospital Name</label>
                                <input type="text" name="hospitalName" value={formData.hospitalName} onChange={handleChange} required />
                            </div>
                            {/* File Upload */}
                            <div className="form-row-claim">
                                <label>Upload Documents</label>
                                <input type="file" name="documents" accept=".pdf,.jpg,.jpeg,.png" onChange={handleChange} />
                                {filePreview.title && (
                                    <div className="file-preview">
                                        <h4>{filePreview.title}</h4>
                                        <div>{filePreview.summary}</div>
                                    </div>
                                )}
                            </div>

                            {/* Remarks */}
                            <div className="form-row full-width">
                                <label>Remarks</label>
                                <textarea name="remarks" value={formData.remarks} onChange={handleChange} />
                            </div>

                            {/* Insurer Email */}
                            <div className="form-row-claim">
                                <label>Insurer Email ID</label>
                                <input type="email" name="insurerEmailID" value={formData.insurerEmailID} onChange={handleChange} required />
                            </div>

                            <div className="form-actions full-width">
                                <button type="submit" disabled={loading}>{loading ? 'Submitting Claim...' : 'Submit Claim'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default EmployeeClaimStatusScreen;
